import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';

export const fetchClassificationCode = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await apiClient.get('/hsn-codes', { params });
  return data;
};

export const useGetClassificationCodesHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [codes, setCodes] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['hsncodes', searchQuery],
    queryFn: fetchClassificationCode,
    keepPreviousData: true,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (fetchedData) {
      setCodes(fetchedData.content);
      setTotalDocuments(fetchedData.total_elements);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        dispatch(showSnackbar({ message: error.response?.data?.message || error.message, severity: 'error' }));
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    codes,
    totalDocuments,
    isLoading,
  };
};
